import { CircularProgress, Grid } from '@material-ui/core';
import { Icons, Typography } from '@nutrien/cxp-components';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

import type { AssetFileInfo } from '../../rxdb/assetDetails/assetDetails.types';
import { useNotification } from '../../utilities';
import { getImage } from '../../utilities/useFileStorage';
import { useOnlineStatus } from '../../utilities/useOnlineStatus';
import { downloadURI } from '../../utilities/utilityFunctions';
import OfflineDialog from '../OfflineDialog';
import useStyles from './AssetFileDetails.styles';

interface Props {
  file: AssetFileInfo;
  key: string;
}

const AssetFileDetails: React.FC<Props> = ({ file }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [offline, setOffline] = useState<boolean>(false);
  const online = useOnlineStatus();
  const { errorNotification } = useNotification();

  const downloadAssetFiles = async (filePath: string, fileName: string) => {
    if (online) {
      setOffline(false);
      setLoading(true);
      try {
        const slicedFilePath = filePath.charAt(0) === '/' ? filePath.slice(1) : filePath;
        const result = await getImage(slicedFilePath);
        const blobPath = await fetch(String(result))
          .then(r => r.blob())
          .then(e => {
            return e;
          });
        const path = URL.createObjectURL(blobPath);
        downloadURI(path, fileName);
        setLoading(false);
      } catch (error) {
        errorNotification('Error while downloading file please try again');
        setLoading(false);
      }
    } else {
      setOffline(true);
    }
  };

  return (
    <>
      <Grid
        onClick={() => downloadAssetFiles(file.path, file.fileName)}
        className={classes.filesStyle}
        data-testid="download-Asset-File"
      >
        <Typography
          variant="subtitle1"
          fontWeight="normal"
          color="primary"
          className={classes.assetfileName}
        >
          {loading ? (
            <CircularProgress className={classes.primaryColor} />
          ) : (
            <Icons.DownloadFeather
              color="primary"
              strokeWidth="2"
              className={classes.downloadIcon}
            />
          )}
          <Typography
            variant="subtitle1"
            fontWeight="normal"
            color="primary"
            className={classes.fileName}
          />
          {file.fileName}
        </Typography>
      </Grid>
      {offline && <OfflineDialog open={offline} onClose={() => setOffline(false)} />}
    </>
  );
};
export default observer(AssetFileDetails);
